import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
} from "@chakra-ui/react";

export default function ModalShell({
  isOpen,
  onClose,
  title,
  children,
  onSubmit,
  submitLabel = "Salvar",
  cancelLabel = "Cancelar",
  isSubmitting = false,
  size = "md",
  // `footer` substitui os botões padrão (ex.: um aviso que pede confirmação antes de salvar)
  footer,
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={size} isCentered>
      <ModalOverlay />
      <ModalContent as={onSubmit ? "form" : undefined} onSubmit={onSubmit}>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{children}</ModalBody>
        <ModalFooter gap={3}>
          {footer ?? (
            <>
              <Button variant="ghost" onClick={onClose} isDisabled={isSubmitting}>
                {cancelLabel}
              </Button>
              {onSubmit ? (
                <Button type="submit" isLoading={isSubmitting}>
                  {submitLabel}
                </Button>
              ) : null}
            </>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
